const isStringStartsWithLetter = (str: string) => /^[a-zA-Z]/.test(str);

export function capitalizeFirstChar(str: string): string {
  // Split string into words (separated by spaces)
  const words = str.split(" ");

  const processedWords = words.map((word) => {
    // Only process words that start with a letter (a-z, A-Z)
    if (isStringStartsWithLetter(word) && word.length > 0) {
      // Capitalize first letter, keep rest unchanged
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    } else {
      // Return word unchanged if it doesn't start with a letter
      return word;
    }
    // }
  });

  return processedWords.join(" ");
}

/** Truncate long text for small screens: "start...end" so it's clear something was shortened */
export function truncateForDisplay(text: string, maxLength = 18): string {
  if (!text || text.length <= maxLength) return text;
  const head = Math.ceil((maxLength - 3) / 2);
  const tail = maxLength - 3 - head;
  return `${text.slice(0, head)}...${text.slice(-tail)}`;
}

export const verifyEmailAddress = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
